import { Injectable } from "@angular/core";
import EsriLoader from "esri-loader";

@Injectable()
export class GeographyService {
  constructor() { }

  geocodeAddress(address: string): Promise<any> {
    const promise = new Promise<any>((resolve, reject) => {
      EsriLoader.loadModules(["esri/tasks/Locator"]).then(([Locator]) => {
        const locator = new Locator({
          url: "http://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer"
        });

        locator
          .addressToLocations({
            address: {
              OBJECTID: "address",
              SingleLine: address
            }
          })
          .then(response => {
            let addressData = response[0];
            resolve({
              latitude: addressData.location.latitude,
              longitude: addressData.location.longitude
            });
          });
      });
    });

    return promise;
  }

  geocodeMap(container: string, latitude: number, longitude: number) {
    const promise = new Promise<any>((resolve, reject) => {
      EsriLoader.loadModules(["esri/Map", "esri/views/MapView", "esri/Graphic"]).then(([Map, MapView, Graphic]) => {
        const map = new Map({
          basemap: "streets-vector" //"streets-relief-vector"
        });

        const view = new MapView({
          container: container,
          map: map,
          center: [latitude, longitude],
          zoom: 10
        });
        
        view.when((response) => {
          const pointGraphic = new Graphic({
            geometry: {
              type: "point",
              longitude: longitude,
              latitude: latitude
            },
            symbol: {
              type: "picture-marker",
              url: "/assets/esri-marker.png", 
              width: "22px",
              height: "22px"
            }
          });
          view.graphics.add(pointGraphic);
          resolve(response);
        })
        
      });
      return promise;
    });
  }

}